import React from "react";
import PropTypes from 'prop-types';
import { Routes, Route, useLocation } from "react-router-dom";

import MandatoryFeedbackPage from "pages/MandatorySurvey/MandatoryFeedback";
import FormsPage from "pages/Forms/Forms";

const WithLocation = ({ Component }) => {
  const location = useLocation();
  return <Component location={location} />;
};

WithLocation.propTypes = {
  Component: PropTypes.elementType.isRequired,
};

const AppRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={<WithLocation Component={MandatoryFeedbackPage} />}
    />
    <Route path="/form/" element={<WithLocation Component={FormsPage} />} />
  </Routes>
);

export default AppRoutes;
